import React, { useEffect, useCallback } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import PropTypes from 'prop-types';

import { format, intervalToDuration, parse } from 'date-fns';

//import theme from '@ecp/common/src/style/theme/default';
import { FlexBox, FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';
import Popup from '@ecp/common/src/components/modal/Popup';
import { ReactComponent as AdulCetiImg } from '@ecp/common/src/assets/icon/icon__adult-certification-center.svg';

import { userInfoState } from '@fo-recoil/common/user/atom';
import { withAdultCertification } from '@fo-recoil/common/user/selector';
import { useAlertDialog } from '@fo-hooks/common/useModal';
import { useMobilians } from '@fo-hooks/interfaces/useMobilians';
import memberMyInfoApi from '@fo-apis/member/memberMyInfoApi';
import { useTheme } from 'styled-components';

const InformationLimitPop = ({ open, onClose, onConfirm }) => {
  const theme = useTheme();
  const { showAlertDialog } = useAlertDialog();
  const { mobilians, resetMobilians, handleMobiliansOpen } = useMobilians();
  const isAdultVerified = useRecoilValue(withAdultCertification);
  const setMemberInfo = useSetRecoilState(userInfoState);

  const isOver19 = useCallback((birthDateStr) => {
    const { years } = intervalToDuration({ start: parse(birthDateStr, 'yyyyMMdd', new Date()), end: new Date() });
    return years >= 19;
  }, []);

  const handleClose = useCallback(() => {
    resetMobilians();
    onClose?.();
  }, [onClose, resetMobilians]);
  const handleConfirm = () => {
    handleMobiliansOpen();
  };
  useEffect(() => {
    if (mobilians && !isAdultVerified) {
      (async () => {
        const { birthDate } = mobilians;
        if (isOver19(birthDate)) {
          const { code } = await memberMyInfoApi.updateAdultCertificationDate(mobilians);
          if (!code) {
            setMemberInfo((prev) => ({ ...prev, adultCertificationDate: format(new Date(), 'yyyy-MM-dd') }));
            onConfirm?.();
            resetMobilians();
          } else {
            showAlertDialog('성인 인증에 실패하였습니다.', handleClose);
          }
        } else {
          showAlertDialog('성인 인증에 실패하였습니다.', handleClose);
        }
      })();
    }
  }, [
    handleClose,
    isAdultVerified,
    isOver19,
    mobilians,
    onClose,
    onConfirm,
    resetMobilians,
    setMemberInfo,
    showAlertDialog,
  ]);
  return (
    <Popup
      header={'정보접근 제한'}
      open={open && !isAdultVerified}
      onCancelClick={handleClose}
      onClose={handleClose}
      onConfirmClick={handleConfirm}
      confirmButtonText={'본인인증'}
    >
      <FlexBoxColumn width="520px">
        <FlexBox width="100%" justify-content="center">
          <AdulCetiImg width={'110px'} height={'110px'} />
        </FlexBox>
        <Spacing top={30} />
        <TextBox size={'18px'} weight={'500'} color={theme.color.text.basic}>
          <TextBox size={'18px'} weight={'500'} color={'#F22214'}>
            19세 미만의 청소년 정보접근이 제한
          </TextBox>
          된 정보로
        </TextBox>
        <TextBox size={'18px'} weight={'500'} color={theme.color.text.basic}>
          <TextBox size={'18px'} weight={'500'} color={theme.color.primary}>
            본인인증
          </TextBox>
          이 필요합니다.
        </TextBox>
        <Spacing top={14} />
        <TextBox width="338px" justify-content="center" style={{ textAlign: 'center' }}>
          본 정보는 청소년 유해 매체물로써 정보통신망 이용 촉진 및 정보보호등에 관한 법률 및 청소년 보호법의 규정에
          의하여 본인인증 이후 사용하실 수 있습니다.
        </TextBox>
      </FlexBoxColumn>
    </Popup>
  );
};
InformationLimitPop.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default InformationLimitPop;
